import { useState } from "react";

export function useAROverlay() {
  const [verticalOffset, setVerticalOffset] = useState(0);

  const BackButtonComponent = ({ onClick }) => (
    <button
      onClick={onClick}
      style={{
        position: "absolute",
        top: 20,
        left: 20,
        zIndex: 100,
        padding: "10px",
        background: "rgba(0,0,0,0.6)",
        color: "white",
        border: "none",
        borderRadius: "6px",
        pointerEvents: "auto",
      }}
    >
      ⬅ Back
    </button>
  );

  const SliderComponent = ({ value, onChange }) => (
    <input
      type="range"
      min="-0.5"
      max="0.5"
      step="0.01"
      value={value}
      onChange={(e) => onChange(parseFloat(e.target.value))}
      style={{
        position: "absolute",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        width: "60%",
        zIndex: 100,
        pointerEvents: "auto",
      }}
    />
  );

  return { verticalOffset, setVerticalOffset, BackButtonComponent, SliderComponent };
}
